import { debounce } from "lodash";
import { globalVariables } from "helper/globalVariables";
import { useEffect, useState } from "react";
import { TableWithPagination } from "shared/Components/tableWithPagination";
import { globalClasses } from "helper/globalClasses";
import { JudgeListMobileTable } from "../ViewJudges/components/JudgeListMobileTable";
import { useLazyQuery } from "@apollo/client";
import { getAllHost } from "redux/features/hostATrial/hostATrial";
import { useMediaQuery } from "react-responsive";
import SearchBar from "shared/Components/search";
import { SearchLocation } from "shared/Components/searchLocation";
import { MultiSelectChipsWithSearchDropdown } from "shared/Components/multiSelectWithSearchAndChips";
import PageInfo from "shared/Components/pageInfo";
import { Button } from "shared/Components/button";

const headData = [
  globalVariables.name,
  globalVariables.email,
  globalVariables.phoneNumber,
  globalVariables.state,
  globalVariables.city,
];

const noviceDropdownData = [
  globalVariables.sit,
  globalVariables.novice,
  globalVariables.advanced,
  globalVariables.excellent,
  globalVariables.premier,
];

export const ViewHosts = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const [levelFilter, setLevelFilter] = useState([]);
  const [stateFilter, setStateFilter] = useState(null);
  const [cityFilter, setCityFilter] = useState(null);
  const [search, setSearch] = useState("");

  const { paginatedDataCls } = globalClasses;

  const [page, setPage] = useState(1);
  
  const [getData, { loading, data }] = useLazyQuery(getAllHost)

  const hostData = data?.getAllHost.data || [];

  const onSearch = (event) => {
    const value = event?.target?.value;
    setSearch(value);
  };

  const debouncedSearch = debounce(onSearch, 1000);

  const handleFilterChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.label);
    setLevelFilter(selectedValues);
  };

  const options = noviceDropdownData.map((data, index) => ({
    label: data,
    value: `option_${index}`,
  }));

  const handlePaginationData = (page = 1) => {
    setPage(page);
  };

  useEffect(() => {
    getData({
      variables: {
        pageNumber: page,
        pageSize: 10,
        level: levelFilter.length === 0 ? null : levelFilter,
        city: cityFilter,
        state: stateFilter,
        search,
        status: "approved",
      },
    });
  }, [page, levelFilter, cityFilter, stateFilter, search]);

  const onClearFilters = () => {
    setCityFilter(null);
    setStateFilter(null);
    setLevelFilter([]);
    setSearch("");
  };

  const renderTableBody = () => {
    return hostData?.map((host, index) => (
      <tr key={host.name}>
        <td className={paginatedDataCls(index)}>{host.name ?? "-"}</td>
        <td className={paginatedDataCls(index)}>{host.email ?? "-"}</td>
        <td className={paginatedDataCls(index)}>{host.phone_number ?? "-"}</td>
        <td className={paginatedDataCls(index)}>{host.state ?? "-"}</td>
        <td className={paginatedDataCls(index)}>{host.city ?? "-"}</td>
      </tr>
    ));
  };
    
  return (
    <>
    <PageInfo title={globalVariables.viewHosts}>
      <Button
        width={"w-auto"}
        label="Clear All Filters"
        onClick={onClearFilters} 
      />
    </PageInfo>
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 my-5 order-3">
      <SearchBar
        defaultValue={search}
        isShadow={true}
        width={"w-full"}
        onChange={debouncedSearch}
        placeholder={"Name"}
        isFaded={true}
      />
        <SearchLocation
          isShadow={true}
          width={"w-full"}
          name="state"
          placeholder={globalVariables.state}
          types={["(states)"]}
          onSelectLocation={(location) => {
            setStateFilter(location);
          }}
          defaultValue={stateFilter}
        />
        <SearchLocation
          isShadow={true}
          width={"w-full"}
          name="city"
          placeholder={globalVariables.city}
          types={["(cities)"]}
          onSelectLocation={(location) => {
            setCityFilter(location);
          }}
          searchBy={stateFilter}
          defaultValue={cityFilter}
        />
        <MultiSelectChipsWithSearchDropdown
          width={"w-full"}
          placeholder={globalVariables.level}
          options={options}
          label=""
          onChange={handleFilterChange}
          defaultSelectedOptions={levelFilter}
        />
      </div>
      <div className="order-4">
        `{isMobile ? (
        <JudgeListMobileTable
          data={hostData}
          loading={loading}
        />
        ) : (
          <TableWithPagination
            headData={headData}
            tableBody={renderTableBody()}
            itemsPerPage={10}
            tableHeight={"md:h-[calc(100vh-10rem)] lg:h-[100vh]"}
            loading={loading}
            totalPage={hostData?.totalPages}
            handlePageChange={(page) => handlePaginationData(page)}
          />
        )}`
      </div>
    </>
  );
};
